module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// ResizeIframe

(function (fox, $) {
	
	fox.registerWidget('ResizeIframe', {
		configure: function () {
			this.registerOptions('', {
				iframeId:  this.getOption('iframeId') || 'meet-contacts',
				reload: true
			});

			this.callParent('configure', arguments);
		},
		init: function () {

			var self = this;

			window.addEventListener('message', function(e) {
				var o = e.data;
				if (o.m == 'resize' && !isNaN(o.height)) {
					document.getElementById(self.getOption('iframeId')).height = o.height;
				} else if (o.m == 'gotopage' && fox.Navigator.get(1) != o.page) {
					self.setOption('reload', false);
					fox.Navigator.update(['meet', o.page], false);
				}
			});

			this.handleEvent(fox.Navigator, 'modified_1', fox.bind(function(argument) {
				if (self.getOption('reload')) {
					self.setTemplateOptions({
						page: '&page=' + fox.Navigator.get(1)
					});
					self.render();
				}
			}));

			this.callParent('init', arguments);
		}

	}, 'Widget');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ../common/widget/layout/resizeIframe.js
// module id = 465
// module chunks = 2